import { MarketingSiteAsyncShell } from "../marketingPages/context/MarketingPagesContext";
import { SiteEditorContent } from "./SiteEditorContent";

export function SiteView() {
  return (
    <MarketingSiteAsyncShell>
      <div className="flex h-full w-full flex-col overflow-hidden" id="site-page-view">
        <SiteEditorContent />
      </div>
    </MarketingSiteAsyncShell>
  );
}

export default SiteView;
